<template>
    <div class="w-full px-4 pb-4 border-b lg:border-r">
        <swiper :class="`swiper${product.id}`" :auto-height="true"
                :allow-touch-move="false">
            <swiper-slide>
                <div class="flex lg:flex-wrap pt-4">
                    <div class="flex-none w-24 lg:w-full relative">
<!--                        <div-->
<!--                            v-if="product.attributes.grade"-->
<!--                            class="absolute inline-flex items-center justify-center w-9 h-6 text-xs font-bold bg-white/[.90] -top-1 right-0 border-black border"-->
<!--                            v-text="product.attributes.grade.value"-->
<!--                        />-->

                        <p
                          v-if="product.tags?.includes('has-free-delivery')"
                          class="absolute -top-1 left-0 lg:text-2xl cursor-pointer"
                          v-tooltip="'Є безкоштовна доставка'"
                        >🚚</p>

                        <Link :href="route('products.show', [product])"
                              @click="onProductClick(product, key)">
                            <ResponsiveImage
                                class="lg:h-56 w-full object-contain select-none"
                                :class="{'opacity-35' : !product.is_active}"
                                :media-item="product.image"
                                :alt="product.title"
                            />
                        </Link>
                    </div>
                    <div class="w-full ml-2 md:ml-0 md:p-1 md:mt-2">
<!--                        <div class="flex justify-between" :class="{'mb-1': product.attributes.weight || product.attributes.quantity}">-->
<!--                            <p-->
<!--                                class="text-gray-400 font-medium text-sm line-clamp-1"-->
<!--                                v-text="product.attributes.country?.value"-->
<!--                            />-->

<!--                            <div v-if="product.attributes.weight || product.attributes.quantity">-->
<!--                                <span-->
<!--                                    class="ml-3 rounded-full pb-0.5 pt-1 px-2 whitespace-nowrap text-sm font-bold border-black border">-->
<!--                                    {{ product.attributes.weight?.value || product.attributes.quantity?.value }}-->
<!--                                </span>-->
<!--                            </div>-->
<!--                        </div>-->
                        <Link
                            class="hover:text-indigo-500 font-medium text-sm"
                            :href="route('products.show', [product])"
                            @click="onProductClick(product, key)"
                        >
                            <p class="lg:line-clamp-2" :class="{'opacity-35' : !product.is_active}">{{ product.title }}</p>
                        </Link>
                        <p class="text-xs mt-1 text-gray-600 uppercase line-clamp-2">{{ product.attributes.descriptors?.value }}</p>
                        <p v-if="!product.is_active" class="text-xs text-gray-500 mt-1">Немає в наявності</p>
                        <div class="flex justify-between items-center mt-3">
                            <span class="inline-block px-1 bg-green-500 font-bold" :class="{'opacity-35' : !product.is_active}">
                                {{ product.price.formatted }}
                            </span>
                            <CartPlus
                                v-if="product.is_active"
                                @click="nextSlide(product)"
                                class="text-indigo-600 cursor-pointer h-7"
                            />
                        </div>
                        <div class="text-xs font-bold flex items-center mt-2">
                            <Coin class="w-5 text-fuchsia-500/70"/>
                            <span class="ml-1 mt-0.5 text-gray-500">+{{ product.bonus.formatted }} бонусів</span>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide v-if="product.is_active">
                <div @click="prevSlide(product)" class="pt-4 mb-2 cursor-pointer">
                    <Chevron class="inline h-4 rotate-180 mb-0.5"/>
                    <span class="ml-3 font-bold">{{ product.title }}</span>
                </div>
                <div class="w-full mb-4" v-for="modification in product.modifications">
                    <InputLabel class="mb-3" :value="modification.title"/>

                    <div class="flex gap-2 flex-wrap">
                        <div
                            v-for="option in modification.options"
                            class="border-2 border-black px-2 whitespace-nowrap cursor-pointer"
                            :class="isOptionSelected(modification, option) ? 'bg-black' : ''"
                            @click="selectModification(modification, option.id)"
                        >
                                                        <span
                                                            class="text-sm font-bold"
                                                            :class="isOptionSelected(modification, option) ? 'text-white' : ''"
                                                        >
                                                            {{ option.title }}
                                                        </span>
                        </div>
                    </div>
                </div>

                <div class="flex justify-between items-center">
                    <NumberInput
                        v-model="addToCartForm.quantity"
                        class="input-small"
                        controls
                        inline
                        center
                        :min="1"
                        :max="100"
                    />

                    <div class="w-14">
                        <PrimaryButton
                            color="indigo"
                            @click="addToCart(product, key)"
                            :loading="addToCartForm.processing"
                        >
                            <CartArrowDown class="h-6"/>
                        </PrimaryButton>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import 'swiper/css';
import PrimaryButton from "@/Components/PrimaryButton.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import NumberInput from "@/Components/Forms/NumberInput.vue";
import ResponsiveImage from "@/Components/ResponsiveImage.vue";
import {Link, router} from "@inertiajs/vue3";
import InputLabel from "@/Components/InputLabel.vue";
import {createToast, withProps} from "mosha-vue-toastify";
import ProductAdded from "@/Components/Toasts/ProductAdded.vue";
import {useApiForm} from "@/Helpers/useApiForm/useApiForm.js";
import CartPlus from "@/Components/Svg/CartPlus.vue";
import CartArrowDown from "@/Components/Svg/CartArrowDown.vue";
import Chevron from "@/Components/Svg/Chevron.vue";
import {ecommerce} from "@/Helpers/zaraz.js";
import Coin from '@/Components/Svg/Coin.vue';
import Truck from '@/Components/Svg/Truck.vue';

export default {
    components: {
        Truck,
        Coin,
        Chevron,
        CartArrowDown,
        CartPlus, InputLabel, SwiperSlide, Link, ResponsiveImage, NumberInput, Swiper, PrimaryButton},
    props: {
        listTitle: String,
        product: Object,
        index: Number,
        isOptionSelected: Function,
        selectedOptions: Array,
        openedSlide: String
    },
    data () {
        return {
            addToCartForm: useApiForm({
                quantity: 1
            }),
        }
    },
    methods: {
        addToCart(product, key) {
            this.addToCartForm
                .transform((data) => ({
                    ...data,
                    modifications: product.modifications.map(modification => {
                        return {
                            modification_id: modification.id,
                            options: modification.options
                                .filter(option => this.isOptionSelected(modification, option))
                                .map(option => option.id)
                        }
                    })
                }))
                .post(this.route('cart.store', {activeProduct: product.id}), {
                    preserveScroll: true,
                    onSuccess: () => {
                        createToast(withProps(ProductAdded, {
                            cartEvent: () => this.emitter.emit('openCart')
                        }), {
                            position: 'bottom-right',
                            hideProgressBar: true
                        })

                        this.prevSlide(product)

                        // TODO: add modifications to analytic
                        ecommerce('Product Added', product, {
                            quantity: this.addToCartForm.quantity,
                        })

                        router.reload({
                            only: ['cartProductsCount']
                        })
                    },
                    onError: (error) => {
                        if (error.response.status === 503) {
                            window.location.reload()
                        }

                        createToast('Сталась неочікувана помилка. Будь ласка, повнори спробу, або напиши нам для вирішення проблеми 🫶', {
                            type: 'danger',
                            position: 'bottom-right',
                        })
                    }
                })
        },
        selectModification(modification, optionId) {
            return this.selectedOptions
                .find((options) => options.modification_id === modification.id)
                .options = [optionId]
        },
        nextSlide(product) {
            if (this.openedSlide) {
                document.querySelector(this.openedSlide)?.swiper.slidePrev(0)
            }

            let openedSlide = `.swiper${product.id}`

            this.$emit('slideOpened', openedSlide)

            const el = document.querySelector(openedSlide)

            el.swiper.slideNext()

            window.scrollTo({
                top: el.offsetTop - 80,
                behavior: 'smooth'
            })
        },
        prevSlide(product) {
            document.querySelector(`.swiper${product.id}`).swiper.slidePrev()
        },
        onProductClick(product, position) {
            ecommerce('Product Clicked', product, {
                category: this.listTitle,
                position
            })
        }
    }
}
</script>
